module.exports = __webpack_public_path__ + "static/media/photo22.47718935.jpg";